import BaseService from "src/packages/BaseService";

export default class TypeService extends BaseService {
	static get className() {
		return "type";
	}
};
